import React from "react";
import PageAncestor from "core/common/page/pageAncestor";
import Toolmenu from "core/components/toolmenu/toolmenu";
import mdEntityService from "core/metamodel/mdEntityService";
import mdConfigService from "core/metamodel/mdConfigService";
import {BlockComp} from "core/components/blockComp/blockComp";
import Grid from "core/grid/domain/grid";
import GridComp from "core/grid/component/gridComp";
import gridService from "core/grid/gridService";
import {ErrorComp} from "core/components/errorComp/errorComp";
import ConfirmationDialog from "core/components/confirmationDialog/confirmationDialog";
import {MODULE, PERMISSION, PageProps, SECURABLE} from "core/metamodel/metaConstant";
import {observer} from "mobx-react";
import {MovingBlocks} from "core/grid/gridUtils";
import {action, ObservableMap} from "mobx";
import {ZzFlatButton, ZzFlatButtonRoute} from "core/components/buttons/buttons";
import {UILOCATION} from "core/grid/component/gridComp";
import MdEntity from "core/metamodel/mdEntity";
import {MdEntityDto} from "core/metamodel/metaDomain";
import FieldDefaultList from "core/metamodel/component/fieldDefaultList";
import FieldValidationList from "core/metamodel/component/fieldValidationList";
import EntityValidationList from "core/metamodel/component/entityValidationList";
import uiService from "core/common/service/uiService";
import {IDomainObject, preSave} from "core/form/formUtils";
import {loc} from "core/common/config/locales";
import {PAGE} from "routes";
import {formatId} from "core/common/utils/utils";



const mdFieldGridLocation = 'mdFieldList';


@observer
export default class EntityDetail extends PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = 'Entity';
  static icon = 'book';
  static protectedPage = true;


  static fetchData(routerParams, query) {
    let entityName = routerParams.id;
    console.log("EntityDetail#fetchData(%O)", entityName);
    // $freshLoadFlag = true;
    // $fetchDataDoneFlag = false;

    let metadataPromise = mdEntityService.fetchEntityMetadata(['EntityValidationTable'], [entityName, 'MdField', 'MdEntity']);
    let gridPromise = gridService.fetchGrids(mdFieldGridLocation);
    let entityDtoPromise = mdConfigService.readEntityDto(entityName);

    return Promise.all([metadataPromise, gridPromise, entityDtoPromise])
      .then(([entityMap, gridLocationMap, entityObject]: [ObservableMap<MdEntity>, any, MdEntityDto]) => {
        entityObject.$entityRef = entityMap.get(entityName);

        entityObject.$movingBlocks = new MovingBlocks(null, false, null,
          new Grid(gridLocationMap.get(mdFieldGridLocation), entityName));

        mdConfigService.entityObject = entityObject;
      });
  }


  /**
   * tohle je tady kvuli prechodu na jiny detail entity (chained details)
   * @param prevProps
   */
  componentDidUpdate(prevProps) {
    if(this.idChanged(prevProps.params.id, this.props.params.id)) {
      mdConfigService.entityObject.$movingBlocks.searchExposedGrids(mdConfigService.entityObject);
    }
  }


  componentDidMount() {
    mdConfigService.entityObject.$movingBlocks.searchExposedGrids(mdConfigService.entityObject);
  }

  componentWillUnmount() {
    mdConfigService.entityObject = null;
  }



  findRootObject() {
    return mdConfigService.entityObject;
  }


  onSave = (evt) => {
    console.log('onSave ');
    uiService.showToolbarActionFlag();


    if (!preSave(mdConfigService.entityObject)) {
      return;
    }

    mdConfigService.saveEntityDto(mdConfigService.entityObject)
      .then( action("entityDtoSave-action", (foJson: IDomainObject) => {
        let wasNew = mdConfigService.entityObject.cleanAfterSave(foJson);
        uiService.hideToolbarActionFlag();
      }), error => {
        mdConfigService.entityObject.$errors = error.getMessages();
      });
  };


  render() {

    let {query, } = this.props;

    let movingBlocks = mdConfigService.entityObject.$movingBlocks;

    return (
      <main className="main-content" style={{display: 'flex', flexDirection: 'column'}}>
        {this._createToolMenu(query.gridLocation, mdConfigService.entityObject)}
        <ErrorComp messages={mdConfigService.entityObject.$errors}/>
        <ConfirmationDialog ref={this.dirtyDialogRefHandler}/>

        <BlockComp style={{marginTop: 10}} header={`Entity ${mdConfigService.entityObject.mdEntity}`}>
          <form >
            <div className="row">

              <div className="col-xs-12 col-sm-6 block-comp-right-border">
                <BlockComp style={{marginTop: 10}} header="Entity">
                  {mdConfigService.entityObject.mdEntity}
                  <br/>
                  TODO: label edit
                </BlockComp>
              </div>


              <div className="col-xs-12 col-sm-6">
                <EntityValidationList entityObject={mdConfigService.entityObject} rootObject={mdConfigService.entityObject} entities={mdEntityService.entityMap} entity={mdEntityService.getEntity('EntityValidationTable')} />
              </div>
            </div>
          </form>
        </BlockComp>



        <GridComp grid={movingBlocks.getBlock(mdFieldGridLocation) as Grid} uiLocation={UILOCATION.main}
                  gridClassName="detail-grid" entities={mdEntityService.entityMap}/>

      </main>
    );


  }


  _createToolMenu(gridLocation, entityObject: MdEntityDto) {
    return (
      <Toolmenu chainGridLocation={gridLocation} backAction={this.onBack} backDisabled={false}>
        <ZzFlatButton onClick={this.onSave} label="Save Entity" permission={PERMISSION.Update}/>
        {entityObject.$entityRef.supportDynamicFields && <ZzFlatButtonRoute onGridToolbar routeName="entityFieldDetail" params={{id: formatId(entityObject.mdEntity, 'new')}} label={loc.i18n`New Dynamic Field`} permission={PERMISSION.New} securable={SECURABLE.entityFieldDetail}/>}
      </Toolmenu>
    );
  }


}




// WEBPACK FOOTER //
// ./src/core/metamodel/entityDetail.tsx